<template>
  <div class="home-page min-h-screen">
    <Navbar />

    <main>
      <!-- Hero Section -->
      <HeroSection />

      <!-- Services Section -->
      <ServicesSection />

      <!-- Sectors/Markets Section -->
      <SectorsSection />

      <!-- Contact Section -->
      <ContactSection />
    </main>

    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
import Footer from '@/components/layout/Footer.vue'
import HeroSection from '@/components/sections/HeroSection.vue'
import ServicesSection from '@/components/sections/ServicesSection.vue'
import SectorsSection from '@/components/sections/SectorsSection.vue'
import ContactSection from '@/components/sections/ContactSection.vue'

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer,
    HeroSection,
    ServicesSection,
    SectorsSection,
    ContactSection
  }
}
</script>
